var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.4997 17.4999H10.833M2.08301 17.9166L6.7074 16.138C7.00318 16.0242 7.15107 15.9673 7.28944 15.8931C7.41234 15.8271 7.52951 15.751 7.63971 15.6654C7.76378 15.5692 7.87582 15.4571 8.09991 15.233L17.4997 5.83326C18.4202 4.91279 18.4202 3.4204 17.4997 2.49993C16.5792 1.57945 15.0868 1.57945 14.1664 2.49992L4.76658 11.8997C4.54249 12.1238 4.43044 12.2358 4.33417 12.3599C4.24865 12.4701 4.17251 12.5873 4.10654 12.7102C4.03226 12.8485 3.97538 12.9964 3.86162 13.2922L2.08301 17.9166ZM2.08301 17.9166L3.79811 13.4574C3.92084 13.1383 3.9822 12.9787 4.08746 12.9057C4.17944 12.8418 4.29326 12.8176 4.40325 12.8386C4.52912 12.8627 4.64999 12.9836 4.89174 13.2253L6.77432 15.1079C7.01607 15.3496 7.13694 15.4705 7.16098 15.5964C7.18198 15.7064 7.15783 15.8202 7.09396 15.9122C7.02088 16.0174 6.86133 16.0788 6.54223 16.2015L2.08301 17.9166Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilLine);
export default __webpack_public_path__ + "static/media/pencil-line.8cd262ec17bc69feb3e974100ccd10ac.svg";
export { ForwardRef as ReactComponent };